// extracted by mini-css-extract-plugin
export default {"changeLink":"XT-z","disabled":"YT-z","inline":"ZT-z"};